import React from "react";

// Ant Design
import { List } from "antd";

const SelectedMetricList = props => {
  const {
    list,
    titleFontStyle,
    selectedCategory,
    selectedFontStyle,
    handleSelectedMetric,
  } = props;

  return (
    <List
      size="large"
      dataSource={list}
      renderItem={item => {
        const chipColor = item.match ? "#1677FF" : "#F77C47";

        var value = item.value;

        if (item.dataType === "Boolean") {
          value = item.value === 1 ? "Yes" : "No";
        }

        return (
          <List.Item
            onClick={() => {
              handleSelectedMetric(item);
            }}
            style={{
              cursor: "pointer",
              border: "1px solid black",
              marginBottom: "0.7em",
              borderRadius: "6px",
              borderLeft: `5px solid ${chipColor}`,
            }}
          >
            <List.Item.Meta
              title={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    titleFontStyle,
                    ...(selectedCategory && selectedCategory.name === item.name
                      ? selectedFontStyle
                      : {}),
                  }}
                >
                  <span>{item.label}</span>
                </span>
              }
              description={value}
            />
          </List.Item>
        );
      }}
    />
  );
};

export default SelectedMetricList;
